import { useTranslation } from 'react-i18next';
import {
  ContactDetails,
  DraftBanner,
  OperatorDetails,
  PageIntro,
  ProseSections,
  useTranslatedList,
  type ProseSection,
} from './shared';

/** Review fix F11/F13: a plain-language DRAFT describing the actual implementation (Cognito,
 * DynamoDB, Polly, Whop, Google sign-in/Fonts; journal stored server-side, not end-to-end
 * encrypted). Pending Mauro's and legal review -- the page says so. */
export function Privacy() {
  const { t } = useTranslation();
  const sections = useTranslatedList<ProseSection>('public.privacy.sections');
  return (
    <div className="prose">
      <PageIntro title={t('public.privacy.title')} lead={t('public.privacy.lead')} />
      <DraftBanner />
      <section className="prose-section" aria-labelledby="privacy-operator">
        <h2 id="privacy-operator">{t('public.privacy.operatorHeading')}</h2>
        <OperatorDetails />
        <ContactDetails />
      </section>
      <ProseSections sections={sections} idPrefix="privacy" />
    </div>
  );
}
